export default __webpack_public_path__ + "static/media/SPECS_MYADFACTORY_360.1a203bbc.pdf";